<hs-header></hs-header>
<router-outlet></router-outlet>
<hs-generic-modal></hs-generic-modal>
<hs-footer></hs-footer>